<div class="container-fluid px-4">
  <div class="card mt-4">
    <div class="card-header">
      <h1 style="font-size:22px">{{japaneseLabel['basicSetting']}}</h1>

      <form (ngSubmit)="onChangePassword(passwordForm)" #passwordForm="ngForm" style="width: 80%;">
        
        <!-- Email -->
        <div class="mb-3">
          <label for="email" class="form-label">{{japaneseLabel['emailAddress']}}</label>
          <input
            type="email"
            class="form-control"
            placeholder="admin＠mail.jp"
            [(ngModel)]="email_address"
            name="email"
            autocomplete="email"
            required
            readonly
            email
            #email="ngModel"
          />
        </div>

        <!-- New Password -->
        <div class="mb-3 form-password-toggle">
          <label class="form-label">{{japaneseLabel['newPassword']}}</label>
          <input
            type="password"
            class="form-control"
            placeholder="パスワードを変更する場合のみ入力してください"
            [(ngModel)]="formData.new_password"
            name="new_password"
            autocomplete="new-password"
            minlength="6"
                   required
            #newPass="ngModel"
            maxlength="50"
          />
           <div *ngIf="newPass.errors?.['minlength'] && (newPass.touched || passwordForm.submitted)" class="text-danger">
            {{errorTexts['newPasswordLength']}}
          </div>
          <div *ngIf="newPass.errors?.['required'] && (newPass.touched || passwordForm.submitted)" class="text-danger">
               {{errorTexts['newPasswordRequired']}}
          </div>
        
        </div>

        <!-- Confirm Password -->
        <div class="mb-3 form-password-toggle">
          <label class="form-label">{{japaneseLabel['confirmPassword']}}</label>
          <input
            type="password"
            class="form-control"
            placeholder="確認用パスワードを入力してください"
            [(ngModel)]="confirmPassword"
            name="confirm_password"
            autocomplete="new-password"
            maxlength="50"
          />
          <div *ngIf="formData.new_password && confirmPassword && formData.new_password !== confirmPassword" class="text-danger">
            {{errorTexts['confirmPasswordMatch']}}
          </div>
        </div>

        <!-- Old Password -->
        <div class="mb-3 form-password-toggle">
          <label class="form-label">{{japaneseLabel['currentPassword']}}</label>
          <input
            type="password"
            class="form-control"
            placeholder="現在のパスワードを入力"
            [(ngModel)]="formData.old_password"
            name="old_password"
            autocomplete="current-password"
            required
            #oldPass="ngModel"
            maxlength="50"
          />
          <div *ngIf="oldPass.errors?.['required'] && (oldPass.touched || passwordForm.submitted)" class="text-danger">
           {{errorTexts['currentPasswordRequired']}}
          </div>
        </div>

        <!-- Submit -->
        <div class="mb-3">
          <button type="submit" class="login-btn" style="border-radius: 5px; font-weight: bold;"
            [disabled]="isSubmitting">
            {{japaneseLabel['registerButton']}}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
